import React from 'react';
import { StyleSheet, css } from 'aphrodite';

const styles = StyleSheet.create({
});

const BuildingSearchResults = (props) => {
  return (
    null
  );
}

export default BuildingSearchResults;


// WEBPACK FOOTER //
// ./src/contents/BuildingSearchResults.jsx